import type { ReactNode } from "react";

const BlockProperty = ({ children }: { children: ReactNode }) => {
	return <>{children}</>;
};

export default BlockProperty;
